import { render, staticRenderFns } from "./veStuHygieneModifyAdmin.vue?vue&type=template&id=24e7d19c&scoped=true"
import script from "./veStuHygieneModifyAdmin.vue?vue&type=script&lang=js"
export * from "./veStuHygieneModifyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7d19c",
  null
  
)

export default component.exports